import { useEffect, useState } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import HeroStory from "../components/HeroStory";
import TrendingRail from "../components/TrendingRail";
import ListenLive from "../components/ListenLive";
import DiscoverMore from "../components/DiscoverMore";
import Personalities from "../components/Personalities";
import FeaturedMedia from "../components/FeaturedMedia";
import Newsletter from "../components/Newsletter";
import SubmissionCallout from "../components/SubmissionCallout";
import SEO, { organizationJsonLd } from "../components/SEO";
import { api } from "../lib/api";

export default function Landing() {
    const [hero, setHero] = useState([]);
    const [trending, setTrending] = useState([]);
    const [people, setPeople] = useState([]);

    useEffect(() => {
        (async () => {
            const [h, t, p] = await Promise.all([
                api.get("/articles", { params: { hero: true, limit: 5 } }),
                api.get("/articles", { params: { trending: true, limit: 6 } }),
                api.get("/personalities"),
            ]);
            setHero(h.data);
            setTrending(t.data);
            setPeople(p.data);
        })().catch(console.error);
    }, []);

    return (
        <div className="bg-black min-h-screen text-white">
            <SEO
                description="MyStreetzMag — Afrobeats, Naija street culture, music, interviews, podcasts and events. The sound of the streets."
                keywords={["Afrobeats", "Naija", "Lagos", "Street Culture", "Music", "MyStreetzMag"]}
                jsonLd={organizationJsonLd()}
            />
            <Header />

            {/* Marquee */}
            <div className="border-b border-streetz-line bg-black">
                <div className="max-w-[1600px] mx-auto px-4 md:px-8 h-10 flex items-center gap-4">
                    <span className="bg-streetz-red text-white overline px-3 py-1 shrink-0 relative z-10">
                        BREAKING
                    </span>
                    <div className="flex-1 overflow-hidden relative">
                        <div className="flex gap-12 animate-marquee whitespace-nowrap will-change-transform">
                            {[...trending, ...trending].map((t, i) => (
                                <span
                                    key={`${t.id || t.slug || "t"}-${i}`}
                                    className="overline text-white/80"
                                >
                                    {t.title} ·
                                </span>
                            ))}
                        </div>
                    </div>
                </div>
            </div>

            <main className="max-w-[1600px] mx-auto px-4 md:px-8 py-8">
                <div className="grid grid-cols-12 gap-6">
                    <HeroStory stories={hero} />
                    <div className="col-span-12 md:col-span-4 flex flex-col gap-6">
                        <TrendingRail items={trending} />
                    </div>
                </div>

                {/* Side rail with listen live + newsletter + submission inline below hero */}
                <div className="grid grid-cols-12 gap-6 mt-6">
                    <div className="col-span-12 md:col-span-8">
                        <DiscoverMore />
                    </div>
                    <div className="col-span-12 md:col-span-4 flex flex-col gap-6">
                        <ListenLive />
                        <Newsletter />
                        <SubmissionCallout />
                    </div>
                </div>

                <Personalities items={people} />

                <FeaturedMedia />
            </main>

            <Footer />
        </div>
    );
}
